import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["children", "rtl", "className", "anchorUrlParameter"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './MultipleQuoteTestimonial.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import TestimonialQuote from '../51_TestimonialQuote/TestimonialQuote';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
export var MultipleQuoteTestimonial = function MultipleQuoteTestimonial(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (!fields) {
    console.info('TestimonialQuote component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TestimonialQuote component is empty: please provide data source]");
    }
    return null;
  }
  var themeName = get(params, 'Color') || get(fields, 'data.item.theme.targetItem.name');
  var quotes = [].concat(_toConsumableArray(get(fields, 'data.item.quotes.targetItems', [])), _toConsumableArray(get(fields, 'data.item.quoteTestimonials', [])));
  var BackgroundColorHex = get(fields, 'data.item.theme.targetItem.BackgroundColorHex');
  var ColorHex = get(fields, 'data.item.theme.targetItem.ColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var renderItems = function renderItems() {
    return quotes.map(function (quote) {
      return /*#__PURE__*/React.createElement(TestimonialQuote, {
        params: params,
        background: BackgroundColorHex ? BackgroundColorHex : primaryPageThemeColor,
        color: BackgroundColorHex ? ColorHex : getColorByTheme(primaryColor),
        fields: {
          data: {
            item: quote
          }
        }
      });
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots;
    return /*#__PURE__*/React.createElement("div", {
      className: "row testimonial testimonial-multiple-quote",
      "data-cy": "testimonial-multiple-media"
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    }, function () {
      return tealiumClickFunc(tealiumMergeClickData({}, params));
    }), /*#__PURE__*/React.createElement("div", {
      className: "testimonial__pagination"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right btn-group-arrows ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickData({}, params));
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickData({}, params));
    })), renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickData({}, params));
    })));
  }));
};
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    className = _ref.className,
    anchorUrlParameter = _ref.anchorUrlParameter,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsWrapper, _extends({
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, otherProps), children);
};
export var commonStyles = "c1uyonf5";
export var ltrStyles = "l1nuc023";
export var rtlStyles = "r1n256d1";
export default MultipleQuoteTestimonial;